import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './historic-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class HistoricDetailComponent extends AbstractCollectionDirective {}
